import { useState } from "react";
import { MdLightbulbOutline } from "react-icons/md";
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import Permissoes from "../../middleware/Permissoes";
import SubMenuOpcoes from "../SubMenuOpcoes";
import Organizacao from "../../middleware/Organizacao";

function MenuOpcoesProjetos(props: menuOpcoes) {

  const [subMenu, setSubMenu] = useState(false)

  function exibirSubMenu() {
    setSubMenu(subMenu => !subMenu)
  }
  
  return (
    <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'consultor', 'desenvolvedor', 'projeto_acesso']}>
      <div>
        <div id="menuOpcoes" onClick={exibirSubMenu}>
          <MdLightbulbOutline id="iconeMenu" color="#ffffff" />
          <p id='tituloMenu'>{props.titulo}</p>
          <h3>Novo</h3>
        </div>
        <div id="submenuOpcoes">
          <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'projeto_todos']}>
              {subMenu && <SubMenuOpcoes redirect={'/projetos'} texto='Todos os Projetos' />}
          </Permissoes>
          <Permissoes permissoes={['master', 'administrativo', 'consultor', 'desenvolvedor', 'projeto_meus']}>
              {subMenu && <SubMenuOpcoes redirect={'/projetos?meus-projetos=true'} texto='Meus Projetos' />}
          </Permissoes>
            <Organizacao organizacao={[`${process.env.REACT_APP_ORGANIZACAO_HG}`]}>
              <Permissoes permissoes={['master', 'projeto_banco_indicadores']}>
                  <>
                    {subMenu && <SubMenuOpcoes redirect={'/banco-indicadores'} texto='Banco de Indicadores' />}
                  </>
              </Permissoes>
            </Organizacao>
        </div>
      </div>
    </Permissoes>
  )
}

export default MenuOpcoesProjetos
